import styled, { keyframes } from "styled-components";
import {
  ModalContainer,
  ModalOverlay,
} from "../BackgroundSelectionModal/index.styled";
import { colors } from "../../../styles/colors";
import { STORY_CONTENT_WIDTH } from "../../../utils/mediaExportUtils";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export { ModalOverlay };

export const MediaAnswerModalOverlay = styled(ModalOverlay)`
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
  overscroll-behavior: none;
  touch-action: none;
  align-items: center;
  height: 100dvh;
  z-index: 3000;
  background-color: rgba(18, 34, 67, 0.55);
  backdrop-filter: blur(8px);
`;

export const MediaAnswerModalContainer = styled(ModalContainer)<{
  $compactPreview?: boolean;
}>`
  width: min(320px, calc(100vw - 20px), calc((100dvh - 148px) * 9 / 16));
  max-width: calc(100vw - 20px);
  max-height: calc(100dvh - 20px);
  margin: auto;
  padding: 0;
  background: ${colors.white};
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(18, 34, 67, 0.18);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
  flex-shrink: 0;

  .modal-title {
    margin: 0;
    padding: 14px 44px 10px 16px;
    font-size: 18px;
    line-height: 1.2;
    flex-shrink: 0;
  }

  .preview-stage {
    position: relative;
    width: 100%;
    aspect-ratio: 9 / 16;
    max-height: calc(
      100dvh - ${({ $compactPreview }) => ($compactPreview ? 230 : 148)}px
    );
    margin: 0;
    border-radius: 0;
    overflow: hidden;
    box-shadow: none;
    flex-shrink: 0;
    min-height: 0;
    direction: ltr;
    touch-action: none;
  }

  .error-message {
    margin: 0;
    padding: 8px 16px 0;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 13px;
    color: ${colors.red};
    text-align: center;
    flex-shrink: 0;
  }

  .actions-row {
    display: flex;
    gap: 8px;
    margin: 0;
    padding: 12px 12px 14px;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    flex-shrink: 0;

    &.post-recording {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
      padding-bottom: 16px;

      .secondary-pair {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
        width: 100%;
      }

      .action-btn {
        min-width: 0;
        width: 100%;
        height: 34px;
        font-size: 11px;
        padding: 0 10px;
        gap: 5px;
        white-space: nowrap;

        svg {
          flex-shrink: 0;
        }
      }
    }
  }

  .action-btn {
    min-width: 120px;
    height: 30px;
    border: none;
    border-radius: 100px;
    padding: 0 14px;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: -0.22px;
    color: #ffffff;
    background: #004ef7;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    white-space: nowrap;
    direction: ltr;
    transition: opacity 0.2s ease;

    &:hover:not(:disabled) {
      opacity: 0.9;
    }

    &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }

    &.danger {
      background: #ff2d55;
    }

    &.secondary {
      background: ${colors.blueGray};
    }

    .loading-icon {
      animation: ${spin} 1s linear infinite;
    }
  }

  .hidden-export-overlay {
    position: absolute;
    left: -9999px;
    top: -9999px;
    pointer-events: none;
  }
`;

export const VoicePreviewStage = styled.div<{ $background: string }>`
  && {
    background: ${({ $background }) => $background};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .hidden-export-overlay {
    width: ${STORY_CONTENT_WIDTH}px;
  }
`;

export const VideoPreviewStage = styled.div<{ $background?: string }>`
  && {
    background: ${({ $background }) => $background ?? "#000000"};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .camera-video,
  .playback-video {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .camera-video.mirrored,
  .playback-video.mirrored {
    transform: scaleX(-1);
  }

  .hidden-export-overlay {
    width: ${STORY_CONTENT_WIDTH}px;
  }
`;
